import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\uD55C\uAD6D\uC5B4",
  code: "ko",
  messages: {
    inputMenu: {
      noMatch: "\uC77C\uCE58\uD558\uB294 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      create: '"{label}" \uC0DD\uC131'
    },
    calendar: {
      prevYear: "\uC774\uC804 \uD574",
      nextYear: "\uB2E4\uC74C \uD574",
      prevMonth: "\uC774\uC804 \uB2EC",
      nextMonth: "\uB2E4\uC74C \uB2EC"
    },
    inputNumber: {
      increment: "\uC99D\uAC00",
      decrement: "\uAC10\uC18C"
    },
    commandPalette: {
      placeholder: "\uBA85\uB839\uC744 \uC785\uB825\uD558\uAC70\uB098 \uAC80\uC0C9...",
      noMatch: "\uC77C\uCE58\uD558\uB294 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      close: "\uB2EB\uAE30"
    },
    selectMenu: {
      noMatch: "\uC77C\uCE58\uD558\uB294 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      create: '"{label}" \uC0DD\uC131',
      search: "\uAC80\uC0C9..."
    },
    toast: {
      close: "\uB2EB\uAE30"
    },
    carousel: {
      prev: "\uC774\uC804",
      next: "\uB2E4\uC74C",
      goto: "{slide} \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"
    },
    modal: {
      close: "\uB2EB\uAE30"
    },
    slideover: {
      close: "\uB2EB\uAE30"
    },
    alert: {
      close: "\uB2EB\uAE30"
    },
    table: {
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
    }
  }
});
